import ADB from "@assets/KPMG/FinancingProducts/Adb.png";
import AFD from "@assets/KPMG/FinancingProducts/AFD.jpg";
import KFW from "@assets/KPMG/FinancingProducts/kfw.jpg";

export const mockData = {
  MDB: [
    {
      id: "3",
      title: "ADB - Asian Development Bank",
      type: "Concessional Finance",
      provider: "ADB",
      image: ADB,
      links: [
        {
          title: "Public Sector Financing",
          href: "https://www.adb.org/what-we-do/public-sector-financing",
        },
        {
          title: "Private Sector Financing",
          href: "https://www.adb.org/what-we-do/private-sector-financing",
        },
        {
          title: "Financing Partnerships",
          href: "https://www.adb.org/what-we-do/financing-partnerships/main",
        },
      ],
    },
    {
      id: "4",
      title: "AFD",
      type: "Concessional Finance",
      provider: "AFD",
      image: AFD,
      links: [
        {
          title: "AFD - Agence Française de Développement",
          href: "https://www.afd.fr/en/finance-projects",
        },
      ],
    },

    {
      id: "5",
      title: "KfW",
      type: "Concessional Finance",
      provider: "KfW",
      image: KFW,
      links: [
        {
          title: "International Financing of KfW | KfW",
          href: "https://www.kfw.de/International-financing/",
        },
      ],
    },
  ],
};
